import createAction from '../services/create-action';

export const APPLICATION_ADDED = 'application/ADDED';

export default createAction(APPLICATION_ADDED);



// WEBPACK FOOTER //
// ./app/actions/application-added.js